// Global State for Coaching Page
export const IS_COACHING_STARTED = "IS_COACHING_STARTED"

// Global state for coaching page for account user
export const IS_UPDATE_SELF_REPORT_SCORECARD_COACHING_STARTED = "IS_UPDATE_SELF_REPORT_SCORECARD_COACHING_STARTED"